import type {
  Breakpoint,
  ModalPriorityMap,
  ProfileModalType,
  ProviderCardViewOption,
} from './uiSlice.types';

export const allBreakpoints: readonly Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

export const xlDownBreakpoints: readonly Breakpoint[] = allBreakpoints;
export const lgDownBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(0, 4);
export const mdDownBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(0, 3);
export const smDownBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(0, 2);
export const xsDownBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(0, 1);

export const xlUpBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(4);
export const lgUpBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(3);
export const mdUpBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(2);
export const smUpBreakpoints: readonly Breakpoint[] = allBreakpoints.slice(1);
export const xsUpBreakpoints: readonly Breakpoint[] = allBreakpoints;

export const MOBILE_CONDENSED_VIEW = 'MOBILE_CONDENSED';
export const MOBILE_EXPANDED_VIEW = 'MOBILE_EXPANDED';
export const DESKTOP_SMALL_VIEW = 'DESKTOP_SMALL';
export const DESKTOP_CONDENSED_VIEW = 'DESKTOP_CONDENSED';
export const DESKTOP_EXPANDED_VIEW = 'DESKTOP_EXPANDED';

export const PROVIDER_CARD_VIEW_OPTIONS: readonly ProviderCardViewOption[] = [
  MOBILE_CONDENSED_VIEW,
  MOBILE_EXPANDED_VIEW,
  DESKTOP_SMALL_VIEW,
  DESKTOP_CONDENSED_VIEW,
  DESKTOP_EXPANDED_VIEW,
] as const;

export const PROFILE_MODAL_TYPES = {
  FEEDBACK: 'feedback',
  SHARE: 'share',
  CALL: 'call',
  COST: 'cost',
  SPECIALTIES: 'specialties',
  INFO: 'info',
  SERVICE_COST: 'service_cost',
  FOCUS_AREAS: 'focus_areas',
  AFFILIATIONS: 'affiliations',
  PLACE_TYPES: 'place_types',
} as const;

export const VALID_PROFILE_MODALS: readonly ProfileModalType[] = Object.values(PROFILE_MODAL_TYPES);

export const modalPriorityMap: ModalPriorityMap = {
  rewards: 1,
  appError: Infinity,
};
